import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActivatedRoute,Router } from '@angular/router';
import { NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { QuoteService } from '../../services/quote.service'
import { FileService } from '../../services/file.service'
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { ContactDetailsComponent } from '../../common/components/contact-details/contact-details.component';
import { QUOTE_APPLICATION } from '../../core/models/quote-register.model';
import { LookupService } from '../../services/lookup.service';
import { HelperService } from '../../services/helper.service';
import { UtilityService } from '../../services/utility.service';
import { ConfigService } from '../../core/services/config.service';
import { IsRowSelectable, GridReadyEvent, GridApi } from 'ag-grid-community';
import { AgGridColumn, AgGridAngular } from 'ag-grid-angular-legacy';
import { AgGridCheckboxComponent } from '../../common/components/ag-grid-checkbox/ag-grid-checkbox.component';
import { CustomButtonCellrenderComponent } from '../custom-button-cellrender/custom-button-cellrender.component';
import { QuoteFileTypes, getStatusName } from '../../core/constants/status.constants'
import * as moment from 'moment';
import { FileDetector } from 'protractor';
import { SettingDto } from 'src/app/core/models/setting.model';
import { MailingAddressComponent } from 'src/app/common/components/mailing-address/mailing-address.component';
import { ValidatorExt } from 'src/app/core/helpers/validators';
import { ADDRESS_TYPES, CONTACT_TYPES } from 'src/app/core/constants/global.constants';
import {Helper} from 'src/app/core/helpers/helper';
import { TooltipDisplayRegisterContext } from 'src/app/services/tooltip-display.types';
import { AgGridHeaderTooltipComponent } from 'src/app/common/components/ag-grid-header-tooltip/ag-grid-header-tooltip.component';

@Component({
  selector: 'app-rtmp',
  templateUrl: './rtmp.component.html',
  styleUrls: ['./rtmp.component.css']
})

export class RtmpComponent implements OnInit {
  public validation_obl_error = "Please select at least one credit obligation from the obligations table in section D.";
  public validation_payment_error = "Please select obligations with a valid payment amount greater than zero";
  private readonly applicantFieldControlNames: string[] = ['name', 'applicantType', 'abn'];
  public viewMode: boolean = false;
  public quote: QUOTE_APPLICATION;
  public selectedObligationPayment: any = {}; 
  public applicationStatus: string = "";
  public obligationData: any = [];
  public acceptedObligations: any = [];
  public rtmpUpdateRequest: any = [];
  public creditStatement: any = {};
  public evidence: boolean = true;
  documents: any = [];
  public pinnedTotalRowData: any[];
  public gridApi: GridApi;
  public creditsGridApi: GridApi;
  public isRFQAfterAmendment: boolean = false;
  public bcfPaymentFee: number = 0;

  public QFNSWDEVFile: string = "";
  public QFNSWAPRFile: string = "";
  public QFCWAPRFile: string = "";
  public QFCRFile: string = "";
  public QFEQSFile: string = "";
  public mapUrl: string = "";
  public shapeFileLocation: string = "";

  public BCFPaymentReferenceNo: string = "";
  public ObligationPaymentId: number = 0;

  public fileTypes: any = [];
  public FILE_TYPE_CODE: string = 'QTEF';
  fileNSW1: any = null;
  fileNSW2: any = null;
  fileCW: any = null;
  fileCR: any = null;
  fileES: any = null;

  public consent1: boolean = false;
  public consent2: boolean = false;
  public invoiceRequired : boolean = false ;
  public invoiceRequiredSelected: boolean = false;
  public creditsChanged: boolean = false;

  public shapeFileUploaded: boolean = false;
  private shapeFileStatusRequestId: number = 0;
  private shapeFileStatusPaymentReferenceNo: string = '';
  public statutoryUploaded: boolean = false;
  public nswDevApplicationSubmitted: boolean = false;
  public commonWealthUploaded: boolean = false;
  public creditReportUploaded: boolean = false;
  public evidenceStatementUploaded: boolean = false;
  public lgas: any = [];
  public developmentTypes: any = [];
  public offsetStatutoryObligationTypes: any[] = [];
  public navigationMode : string = "";
  public shapeFileMessage: string = "";
  paymentNumber: string = '';
  paymentId: number = 0;
 
  private payerApplicantId: number | null = 0;
  private payerContactId: number = 0;
  private payerAddressId: number = 0;

  //frameworkComponents = {
  //  customCellRenderer: CustomRtmpCellrenderComponent
  //};

  public fgQuote: UntypedFormGroup;
  @ViewChild('obligationsGrid', { static: false }) obligationGrid: AgGridAngular;
  @ViewChild('applicantMailingAddress', { static: true }) applicantMailingAddress: MailingAddressComponent;
  @ViewChild('applicantContact', { static: true }) applicantContact: ContactDetailsComponent;
  @ViewChild('secondaryContact', { static: true }) secondaryContact: ContactDetailsComponent;
  @ViewChild('payerContact', { static: false }) payerContact: ContactDetailsComponent;
  @ViewChild('payerMailingAddress', { static: false }) payerMailingAddress: MailingAddressComponent;

  public obligationGridColumns: AgGridColumn[] | any[] = [];
  private hasAppliedInitialGridTotals: boolean = false;

  readonly mailingAddressTooltipContext: TooltipDisplayRegisterContext = {
      register: 'Payment',
      tab: 'RTMP',
      section: 'Quote',
      fieldName: 'Mailing address'
    };
  
     readonly primaryContactTooltipContext: TooltipDisplayRegisterContext = {
      register: 'Payment',
      tab: 'RTMP',
      section: 'Contact Details',
      fieldName: 'Primary contact'
    };
  
    readonly secondaryContactTooltipContext: TooltipDisplayRegisterContext = {
      register: 'Payment',
      tab: 'RTMP',
      section: 'Contact Details',
      fieldName: 'Secondary contact'
    };

  constructor(private formBuilder: UntypedFormBuilder, private quoteService: QuoteService,
    private activeRoute: ActivatedRoute, private router: Router,private helperService: HelperService, private lookup: LookupService,
    private utilityService: UtilityService, private fileService: FileService,
    private configService: ConfigService) {
  }

  ngOnInit() {

  //  if (this.activeRoute.snapshot.url.toString().indexOf('view') != -1)
  //    this.viewMode = true;

    // Get paymentNumber from router state securely
    // Check both current navigation and history state for better reliability
    let navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.state?.['paymentNumber']) {
      this.paymentNumber = navigation.extras.state['paymentNumber'];
      this.paymentId = navigation.extras.state['paymentId'];
      this.navigationMode = "RTMP";
    } else if (history.state?.paymentNumber) {
      this.paymentNumber = history.state.paymentNumber;
      this.paymentId = history.state.paymentId;
      this.navigationMode = "RTMP";
    } else {
      this.paymentNumber = '';
      this.paymentId = 0;
    }

    this.initializeForm();
    this.loadLookups();

    const id = Number(this.activeRoute.snapshot.paramMap.get('id'));

    if (!isNaN(id) && id > 0) {
      this.loadQuote(id);
      this.loadDocuments(id);
      this.initMapUrl();

    }

  }

  public defaultColDef = {
    flex: 1,
    resizable: true,
    //floatingFilter: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
  };

  public pinnedRowStyle(params): any {
    if (params.node.rowPinned) {
      return { 'font-weight': 'bold' };
    }
  }

  get selectedObligationsCount(): number {
    let count = 0;
    if (this.obligationData == null) return 0;
    this.obligationData.forEach(item => {
      if (item.selected)
        count++;
    });

    return count;
  }

  loadLookups() {

    //get file types
    const quoteFileTypeClassification = [this.FILE_TYPE_CODE];
    this.lookup.getClassifications(quoteFileTypeClassification).subscribe(results => {
      this.fileTypes = results;
    });

    //get LGAs;
    this.lookup.getLGAs().subscribe(results => { this.lgas = results; });

    //get development types
    this.lookup.getDevelopmentTypes().subscribe(results => { this.developmentTypes = results });

    this.quoteService.getQuoteRegisterSettings().subscribe(settings => {
      const find = (code: string) => settings.find((s: any) => s.code === code);
      this.bcfPaymentFee = find('QTEBCFFEE')?.decimalValue ?? 0;
    });

    this.lookup.getClassifications(['OBLT']).subscribe(result => {
      this.offsetStatutoryObligationTypes = result;
    });

    
  }

 
  private getDevelopmentTypeId(typeName: string): number | string {
    const normalizedName = (typeName || '').toString().trim().toLowerCase();
    if (!normalizedName) {
      return '';
    }

    const developmentType = this.developmentTypes.find((x: any) =>
      (x?.name || '').toString().trim().toLowerCase() === normalizedName
    );

    return developmentType?.id ?? '';
  }

  private getOffsetTypeValue(rawValue: string): string {
    const value = (rawValue || '').toString().trim();
    if (!value) {
      return '';
    }

    const normalized = value.toLowerCase();
    const obligationType = this.offsetStatutoryObligationTypes.find((item: any) => {
      const code = (item?.code || '').toString().trim().toLowerCase();
      const name = (item?.name || '').toString().trim().toLowerCase();
      return code === normalized || name === normalized;
    });

    return obligationType?.name || value;
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.applyInitialGridTotalsOnce();
  }

  onCreditsGridReady(params: any) {
    this.creditsGridApi = params.api;
    this.creditsGridApi.sizeColumnsToFit();
  }

  private applyInitialGridTotalsOnce(): void {
    if (this.hasAppliedInitialGridTotals) {
      return;
    }

    if (!this.gridApi || !Array.isArray(this.obligationData) || this.obligationData.length === 0) {
      return;
    }

    this.setPaymentGridPinnedTotalRow();
    this.gridApi.refreshCells({ force: true });
    this.hasAppliedInitialGridTotals = true;
  }


  rowSelected($event: any) {
    // Refresh the creditsToPay column cell to show/hide input box based on checkbox selection
    if (this.gridApi && $event.node) {
      this.gridApi.refreshCells({
        rowNodes: [$event.node],
        columns: ['creditsToPay'],
        force: true
      });
    }
  }

  creditClassColumnDefs: any = [
    
    {
      headerName: 'Quote Obligation No', field: 'referenceNumber', sortable: true, filter: 'agTextColumnFilter', minWidth: 50
    },
    {
      headerName: 'IBRA Subregion', field: 'ibraSubregion', sortable: true, filter: 'agTextColumnFilter', minWidth: 175,
    },
    {
      headerName: 'Credit category', field: 'creditCategory', sortable: true, filter: 'agTextColumnFilter',  minWidth: 100
    },
    {
      headerName: 'Credit type ID', field: 'creditTypeId', sortable: true, filter: 'agTextColumnFilter',  minWidth: 100
    },
    {
      headerName: 'Offset trading group', field: 'offsetTradingGroup', sortable: true, filter: 'agTextColumnFilter', minWidth: 250
    },
    {
      headerName: 'HBT status', field: 'hbt', sortable: true, filter: 'agTextColumnFilter', minWidth: 50,
      valueGetter: (params: any) => Helper.hbtValueGetter({ data: params.data })
    },
    {
      headerName: 'EPBC Act offset', field: 'commonwealthOffset', sortable: true, filter: 'agTextColumnFilter', minWidth: 50
    },
    {
      headerName: 'No. of BAM Credits', field: 'totalCredits', sortable: true, filter: 'agTextColumnFilter',  minWidth: 75, type: 'rightAligned'
    }
  ];


  private initializeObligationColumns(): void {
    this.obligationGridColumns = this.buildObligationColumns(false);

    this.applyObligationColumnDefs();
  }

  private initializeViewObligationColumns(): void {
    this.obligationGridColumns = this.buildObligationColumns(true);

    this.applyObligationColumnDefs();
  }

  private buildObligationColumns(isViewMode: boolean): any[] {
    const baseColumns = isViewMode ? this.getViewModeBaseColumns() : this.getEditModeBaseColumns();
    const priceColumns = this.isRFQAfterAmendment
      ? this.getAfterAmendmentPriceColumns()
      : this.getBeforeAmendmentPriceColumns();

    return [...baseColumns, ...priceColumns];
  }

    private getPinnedLabelColSpan(isViewMode: boolean): number {
    if (this.isRFQAfterAmendment) {
      return isViewMode ? 8 : 9;
    }

    return isViewMode ? 9 : 10;
  }



  private getViewModeBaseColumns(): any[] {
    return [
      {
        headerName: 'Quote Obligation no.', field: 'referenceNumber', sortable: true, filter: 'agTextColumnFilter', minWidth: 150, maxWidth: 150,
        colSpan: (params: any) => {
          if (params.node?.rowPinned) {
            return this.getPinnedLabelColSpan(true);
          }
          return 1;
        },
        cellStyle: (params: any) => {
          if (params.node?.rowPinned) {
            return { textAlign: 'right' };
          }
          return null;
        }
      }
    ];
  }

  private getEditModeBaseColumns(): any[] {
    return [
      {
        headerName: 'Select credit class for payment',
        cellRendererFramework: AgGridCheckboxComponent,
        field: 'selected', minWidth: 150,
        cellStyle: (params: any) => {
          if (this.viewMode)
            return { 'display': 'none' }

          if (params.node.rowPinned)
            return { 'display': 'none' }
          else {
            if (params.data.predictedPrice > 0)
              return params;
            else
              return { 'display': 'none' }
          }
        }
      },
      {
        headerName: 'Enter No. of credits for payment',
         headerComponent: AgGridHeaderTooltipComponent,
              headerComponentParams: {
                tooltipContext: {
                  register: 'Payment',
                  tab: 'RTMP',
                  section: 'Payment Details',
                  fieldName: 'Credit'
                }
              },
        field: 'creditsToPay',
        sortable: true,
        filter: 'agTextColumnFilter',
        minWidth: 150,
        editable: false,
        type: 'rightAligned',
        cellRenderer: (params: any) => {
          if (this.viewMode || params.node.rowPinned) {
            return `<div style="text-align: right; padding: 8px;">${params.value || ''}</div>`;
          }
          if (!params.data.selected) {
            return `<div style="text-align: right; padding: 8px;">${params.data.totalCredits || ''}</div>`;
          }
          const inputId = `credit-input-${params.node.id}`;
          setTimeout(() => {
            const input = document.getElementById(inputId);
            if (input) {
              const creditsInput = input as HTMLInputElement;
              creditsInput.addEventListener('input', () => {
                creditsInput.value = creditsInput.value.replace(/\D/g, '');
              });
              creditsInput.addEventListener('keydown', (event: KeyboardEvent) => {
                if (event.key === 'Enter') {
                  event.preventDefault();
                  creditsInput.blur();
                } else if (event.key === 'Escape') {
                  creditsInput.value = String(params.node.data.creditsToPay ?? 1);
                  creditsInput.blur();
                }
              });
              creditsInput.addEventListener('blur', () => {
                this.commitCreditsToPay(params.node.data, params.node, creditsInput);
              });
            }
          }, 0);
          return `<input id="${inputId}" type="text" inputmode="numeric" pattern="[0-9]*" autocomplete="off" class="form-control"
                  style="width: 100%; height: 100%; border: 1px solid #dee2e6; text-align: right; padding: 4px 8px;" 
                  value="${params.value || 1}" />`;
        }
      },
      {
        headerName: 'Quote Obligation no.', field: 'referenceNumber', sortable: true, filter: 'agTextColumnFilter', minWidth: 150, maxWidth: 150,
        colSpan: (params: any) => {
          if (params.node?.rowPinned) {
            return this.getPinnedLabelColSpan(false);
          }
          return 1;
        },
        cellStyle: (params: any) => {
          if (params.node?.rowPinned) {
            return { textAlign: 'right' };
          }
          return null;
        }
      },
      {
        headerName: 'View past payments',
         headerComponent: AgGridHeaderTooltipComponent,
              headerComponentParams: {
                tooltipContext: {
                  register: 'Payment',
                  tab: 'RTMP',
                  section: 'Payment Details',
                  fieldName: 'View'
                }
              },
        cellRendererFramework: CustomButtonCellrenderComponent,
        field: 'id',
        minWidth: 115,
        cellStyle: (params: any) => {
          if (this.viewMode || params.node.rowPinned || params.data.convertedToObligation == null || !params.data.convertedToObligation)
            return { 'display': 'none' }
        }
      }
    ];
  }

  private commitCreditsToPay(rowData: any, rowNode: any, input: HTMLInputElement): void {
    const enteredValue = input.value.trim();
    const newValue = Number(enteredValue);
    const currentValue = Number(rowData?.creditsToPay ?? 1);

    if (!rowData || !/^\d+$/.test(enteredValue) || !Number.isSafeInteger(newValue) || newValue < 1) {
      input.value = String(currentValue);
      return;
    }

    if (currentValue === newValue) {
      return;
    }

    rowData.creditsToPay = newValue;
    rowData.paymentPerCredit = Number(rowData.obligationPaymentPerCredit || 0) * newValue;
    this.creditsChanged = true;
    this.updateTotal();

    if (this.gridApi) {
      this.gridApi.refreshCells({ rowNodes: [rowNode], force: true });
    }
  }

  private getBeforeAmendmentPriceColumns(): any[] {
    return [
      {
        headerName: 'No. of credits quoted ', field: 'totalCredits', sortable: true, filter: 'agTextColumnFilter',
        minWidth: 100, type: 'rightAligned'
      },
      {
        headerName: 'Predicted price per credit (Exc. GST)', field: 'predictedPrice', sortable: true, filter: 'agTextColumnFilter', minWidth: 130,
        valueFormatter: (params: any) => this.helperService.formatCurrency(params.value),
        type: 'rightAligned'
      },
      {
        headerName: 'Risk premium per credit (Exc. GST)', field: 'riskPremium', sortable: true, filter: 'agTextColumnFilter', minWidth: 120,
        valueFormatter: (params: any) => this.helperService.formatCurrency(params.value),
        type: 'rightAligned'
      },
      {
        headerName: 'Delivery fee per credit (Exc. GST)', field: 'deliveryFee', sortable: true, filter: 'agTextColumnFilter', minWidth: 120,
        valueFormatter: (params: any) => this.helperService.formatCurrency(params.value),
        type: 'rightAligned'
      },
      {
        headerName: 'Monthly Indexation per credit (Exc. GST)', field: 'monthlyIndexation', sortable: true, filter: 'agTextColumnFilter', minWidth: 120,
        valueFormatter: (params: any) => this.helperService.formatMonthlyIndexation(params.value),
        type: 'rightAligned'
      },
      {
        headerName: 'No. of whole months lapsed ', field: 'monthsLapsed', sortable: true, filter: 'agTextColumnFilter', minWidth: 100,
        type: 'rightAligned'
      },
      {
        headerName: 'Indexation per credit ', field: 'indexationPerCredit', sortable: true, filter: 'agTextColumnFilter', minWidth: 100,
        valueFormatter: (params: any) => this.helperService.formatCurrency(params.value),
        type: 'rightAligned'
      },
      {
        headerName: 'Indexed Obligation payment per credit (Exc. GST)', field: 'obligationPaymentPerCredit', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: (params: any) => this.helperService.formatCurrency(params.data.obligationPaymentPerCredit),
        type: 'rightAligned'
      },
      {
        headerName: 'Total obligation payment (Exc. GST)', field: 'paymentPerCredit', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: (params: any) => {
          return this.helperService.formatCurrency(params.data.paymentPerCredit)
        },
        type: 'rightAligned'
      }
    ];
  }

  private getAfterAmendmentPriceColumns(): any[] {
    return [
      {
        headerName: 'No. of credits quoted ', field: 'totalCredits', sortable: true, filter: 'agTextColumnFilter',
        minWidth: 100, type: 'rightAligned'
      },
      {
        headerName: 'Predicted price per credit (Exc. GST)', field: 'predictedPrice', sortable: true, filter: 'agTextColumnFilter', minWidth: 130,
        valueFormatter: (params: any) => this.formatCurrencyForPinnedTotal(params.value, params?.node?.rowPinned),
        type: 'rightAligned'
      },
      {
        headerName: 'Risk premium per credit (Exc. GST)', field: 'riskPremium', sortable: true, filter: 'agTextColumnFilter', minWidth: 120,
        valueFormatter: (params: any) => this.formatCurrencyForPinnedTotal(params.value, params?.node?.rowPinned),
        type: 'rightAligned'
      },
      {
        headerName: 'Delivery fee per credit (Exc. GST)', field: 'deliveryFee', sortable: true, filter: 'agTextColumnFilter', minWidth: 120,
        valueFormatter: (params: any) => this.formatCurrencyForPinnedTotal(params.value, params?.node?.rowPinned),
        type: 'rightAligned'
      },
      {
        headerName: 'External fee per credit (Exc. GST)', field: 'externalFeePerCredit', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: (params: any) => this.formatCurrencyForPinnedTotal(params.value, params?.node?.rowPinned),
        type: 'rightAligned'
      },
      {
        headerName: 'Predicted price (GST Payable)', field:'totalpredictedPrice', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: (params: any) => this.formatCurrencyForPinnedTotal(params?.data?.totalpredictedPrice, params?.node?.rowPinned),
        type: 'rightAligned'
      },
      {
        headerName: 'Risk premium (GST Payable)', field:'totalRiskPremium', sortable: true, filter: 'agTextColumnFilter', minWidth: 150,
        valueFormatter: (params: any) => this.formatCurrencyForPinnedTotal(params?.data?.totalRiskPremium, params?.node?.rowPinned),
        type: 'rightAligned'
      },
      {
        headerName: 'Obligation payment excluding fees (GST Payable)', 
        valueGetter: (params: any) => this.formatCurrencyForPinnedTotal(params?.data?.totalPriceExclFee, params?.node?.rowPinned), 
        sortable: true, filter: 'agTextColumnFilter', minWidth: 225, type: 'rightAligned'
      },
      {
        headerName: 'Delivery cost - Per credit and fixed fee (GST payable)', 
        valueGetter: (params: any) => this.formatCurrencyForPinnedTotal(params?.data?.totalDeliveryFee, params?.node?.rowPinned), 
        sortable: true, filter: 'agTextColumnFilter', minWidth: 225, type: 'rightAligned'
      },
      {
        headerName: 'Delivery cost - External fee (Non-GST)', 
        valueGetter: (params: any) => this.formatCurrencyForPinnedTotal(params?.data?.totalExternalFee, params?.node?.rowPinned), 
        sortable: true, filter: 'agTextColumnFilter', minWidth: 225, type: 'rightAligned'
      },
      {
        headerName: 'Total obligation payment (Exc. GST)', field: 'totalPayment', 
        valueGetter: (params: any) => this.formatCurrencyForPinnedTotal(params?.data?.totalPayment, params?.node?.rowPinned), 
        sortable: true, filter: 'agTextColumnFilter', minWidth: 200, type: 'rightAligned',
        cellStyle: (params: any) => params.node.rowPinned ? { fontWeight: 'bold' } : null
      }
    ];
  }

  private formatCurrencyForPinnedTotal(value: any, rowPinned: boolean): string {
    const amount = Number(value);
    const safeAmount = Number.isFinite(amount) ? amount : 0;

    if (rowPinned && safeAmount === 0) {
      return '-';
    }

    return this.helperService.formatCurrency(safeAmount);
  }

  private applyObligationColumnDefs(): void {
    if (this.gridApi) {
      this.gridApi.setColumnDefs(this.obligationGridColumns);
    }
  }

  public isRowSelectable: IsRowSelectable = (params) => {
    return !!params.data;
  };

  public onCellValueChanged(event) {

    if (event.column.colId == 'commonwealthOffset') {
      return;
    }

    if (event.column.colId == 'selected') {
      // Refresh the creditsToPay column when checkbox is toggled
      if (this.gridApi && event.node) {
        this.gridApi.refreshCells({
          rowNodes: [event.node],
          columns: ['creditsToPay'],
          force: true
        });
      }
      this.updateTotal();
      return;
    }

    if (event.column.colId == "creditsToPay" || event.column.colId == "totalCredits") {
      //recalculat grid totals.
      let oldValue = +event.oldValue;
      let newValue = +event.newValue;

      if (oldValue != newValue) {
        this.creditsChanged = true;
        event.node.data.paymentPerCredit = event.data.obligationPaymentPerCredit * newValue;

        // In after-amendment mode, there is no paymentPerCredit column definition.
        // Calling setDataValue on a non-existent column causes AG Grid getColDef null errors.
        const hasPaymentPerCreditColumn = !!this.gridApi?.getColumnDef('paymentPerCredit');
        if (hasPaymentPerCreditColumn) {
          event.node.setDataValue('paymentPerCredit', event.node.data.paymentPerCredit);
        }

        this.updateTotal();
      }
    }
  }

  initializeForm() {
    const MAX_FILE_LENGTH = 100;
    this.fgQuote = this.formBuilder.group({
      referenceNumber: new UntypedFormControl({ value: '', disabled: true }),
      issuedDate: new UntypedFormControl({ value: '', disabled: true }),
      bcfPaymentNumber: new UntypedFormControl({ value: '', disabled: true }),
      primaryStatus: new UntypedFormControl({ value: '', disabled: true }),
      secondaryStatus: new UntypedFormControl({ value: '', disabled: true }),

      name: new UntypedFormControl({ value: '', disabled: false }, Validators.required),
      applicantType: new UntypedFormControl({ value: '', disabled: false }),
      abn: new UntypedFormControl({ value: '', disabled: false }, Validators.compose([Validators.required, ValidatorExt.abnAcn()])),
      organisation: new UntypedFormControl({ value: '', disabled: this.viewMode }),

      developmentName: new UntypedFormControl({ value: '', disabled: this.viewMode }, Validators.required),
      developmentType: new UntypedFormControl({ value: '', disabled: this.viewMode }, Validators.required),
      lga: new UntypedFormControl({ value: '', disabled: this.viewMode }, Validators.required),
      offsetType: new UntypedFormControl({ value: '', disabled: this.viewMode }, Validators.required),
      nswReference: new UntypedFormControl({ value: '', disabled: this.viewMode }, Validators.required),
      commonWealthReference: new UntypedFormControl({ value: '' }),
      nswApprovalAuthority: new UntypedFormControl({ value: '' }, Validators.required),
      nswApprovalDate: new UntypedFormControl({ value: '' }, Validators.required),
      assessmentOffsetScheme: new UntypedFormControl({ value: '' }, Validators.required),
      authOption: new UntypedFormControl({ value: '', disabled: this.viewMode }),
      authName: new UntypedFormControl({ value: '', disabled: this.viewMode }),
      authOrganisation: new UntypedFormControl({ value: '', disabled: this.viewMode }),

      preparationDate: new UntypedFormControl({ value: '', disabled: true }),
      monthsLapsed: new UntypedFormControl({ value: '', disabled: true }),

      nsw1: new UntypedFormControl(null, Validators.maxLength(MAX_FILE_LENGTH)),
      nsw2: new UntypedFormControl(null, Validators.maxLength(MAX_FILE_LENGTH)),
      cw: new UntypedFormControl(null, Validators.maxLength(MAX_FILE_LENGTH)),
      cr: new UntypedFormControl(null, Validators.maxLength(MAX_FILE_LENGTH)),
      es: new UntypedFormControl(null, Validators.maxLength(MAX_FILE_LENGTH)),


      QFNSWDEV: new UntypedFormControl({ value: false, disabled: true }),
      QFNSWAPR: new UntypedFormControl({ value: false, disabled: true }),
      QFCWAPR: new UntypedFormControl({ value: false, disabled: true }),
      QFCR: new UntypedFormControl({ value: false, disabled: true }),
      QFEQS: new UntypedFormControl({ value: false, disabled: true }),

      isPayerSameAsApplicant: new UntypedFormControl({ value: '', disabled: false }),
      payerName: new UntypedFormControl({ value: '', disabled: false }),
      payerType: new UntypedFormControl({ value: '', disabled: false }),
      payerABN: new UntypedFormControl({ value: '', disabled: false }, Validators.compose([Validators.required, ValidatorExt.abnAcn()])),

    });
    this.initializeObligationColumns();
    this.shapeFileMessage = "Upload shapefile after saving draft and once BCF payment number is generated.";

    this.fgQuote.get('applicantType')?.valueChanges.subscribe(() => this.updateAbnValidators());
    this.fgQuote.get('payerType')?.valueChanges.subscribe(() => this.updatePayerAbnValidators());
    this.updateAbnValidators();
    this.updatePayerAbnValidators();

  }

  private updateAbnValidators(): void {
    const abnControl = this.fgQuote?.get('abn');
    if (!abnControl) {
      return;
    }

    const applicantType = (this.fgQuote.get('applicantType')?.value || '').trim();
    if (applicantType === 'IND') {
      abnControl.setValidators(ValidatorExt.abnAcn());
    } else {
      abnControl.setValidators(Validators.compose([Validators.required, ValidatorExt.abnAcn()]));
    }
    abnControl.updateValueAndValidity({ emitEvent: false });

  }

  private updatePayerAbnValidators(): void {
    const payerAbnControl = this.fgQuote?.get('payerABN');
    if (!payerAbnControl) {
      return;
    }

    const payerType = (this.fgQuote.get('payerType')?.value || '').trim();
    if (payerType === 'IND') {
      payerAbnControl.setValidators(ValidatorExt.abnAcn());
    } else {
      payerAbnControl.setValidators(Validators.compose([Validators.required, ValidatorExt.abnAcn()]));
    }
    payerAbnControl.updateValueAndValidity({ emitEvent: false });
  }

  //if it comes from quote grid, if there is already a payment in draft mode, show that payment number
  //if it comes from quote grid and there are no payments and no payment in draft mode, show bcfreference number as empty and enable save draft
  //if it comes from payment grid, if the payment in progress mode, set view mode to true
  //if it comes from payment grid, and payment is in draft mode, set view mode to false and enable saving

  loadQuote(id: number) {
    this.BCFPaymentReferenceNo = '';
    this.setShapeFileMessage('');
    this.fgQuote.reset();
   this.fgQuote.patchValue({
      preparationDate: moment().format('DD/MM/YYYY'),
      monthsLapsed: '',
      isPayerSameAsApplicant: '',
    });

    this.quoteService.get(id).subscribe(result => {
      this.quote = result;
      this.selectedObligationPayment = null;

      this.isRFQAfterAmendment = !!result?.isRFQAfterAmendment;
      let date = this.quote.issuedDate ? this.quote.issuedDate.slice(0, 10) : "";
      let months = moment(date).isValid() ? moment().diff(moment(date), 'months') : 0;
      date = this.helperService.dateFormat(date, "DD/MM/yyyy");
      
      if(result.obligationPayments != null && result.obligationPayments.length > 0){
        if(this.paymentNumber && this.paymentNumber !== '') {
          // Find the specific payment matching the paymentNumber
          const matchingPayment = result.obligationPayments.find(payment => 
            payment.bcfReferenceNumber === this.paymentNumber
          );
          this.selectedObligationPayment = matchingPayment;

          if(matchingPayment && matchingPayment.status !== 'DFT') {
            this.viewMode = true;
          }
        } else {
          //if the route is from quote grid, check if there is draft status
          const hasDftStatus = result.obligationPayments.some(payment => payment.status === 'DFT');        
          this.selectedObligationPayment = (result.obligationPayments as any[]).find((payment: any) => payment.status === 'DFT') ?? null;
          if(!hasDftStatus && this.navigationMode == "RTMP") {
            this.viewMode = true ;
          }
        }
        this.payerApplicantId = this.selectedObligationPayment?.payerId ?? null; 
        this.setPayerDetails();

      }
      this.setDevelopmentDetails();
      this.syncApplicantControlState();
      this.syncDevelopmentControlState();

      this.fgQuote.patchValue({
        referenceNumber: this.quote.referenceNumber,
        issuedDate: date,
        monthsLapsed: months.toString()
      });

   

      // Load statement only after viewMode and amendment flags are resolved.
      this.loadQuoteStatement(id);

      //get payment number if already  in not view mode
      if (this.viewMode) {
          this.fgQuote.patchValue({ bcfPaymentNumber: this.paymentNumber });
          this.initializeViewObligationColumns();
          this.setShapeFileMessage(this.selectedObligationPayment?.bcfReferenceNumber || this.paymentNumber);
      }
      else {
        this.initializeObligationColumns();
        this.quoteService.getQuoteApplicationStatus(id).subscribe(response => {
          // Handle case where paymentReferenceNumber may or may not contain comma
          if (response.paymentReferenceNumber && response.paymentReferenceNumber.includes(',')) {
            const ref = response.paymentReferenceNumber.split(',');
            this.BCFPaymentReferenceNo = ref.length > 0 ? ref[0].trim() : '';
          } else {
            this.BCFPaymentReferenceNo = response.paymentReferenceNumber || '';
          }
          //this.BCFPaymentReferenceNo = response.paymentReferenceNumber;
          this.applicationStatus = response.status;
          this.ObligationPaymentId = response.obligationPaymentId;

          //for already submitted status, set the bcf to , and payment id to 0 so that it can be submitted multiple times
          if(response.status != "DFT" && response.status != "NEW" ){
            this.BCFPaymentReferenceNo = '' ;
             this.ObligationPaymentId = 0;
              this.payerApplicantId = null;  //reset payer details
          }
          this.setShapeFileMessage(this.BCFPaymentReferenceNo);
          this.fgQuote.patchValue({
            bcfPaymentNumber: response.paymentReferenceNumber,
            //nswApprovalAuthority: response.nswApprovalAuthority,
            //nswApprovalDate: response.nswApprovalDate,
            isPayerSameAsApplicant: this.ObligationPaymentId === 0 ? '' : (this.payerApplicantId ? 'no' : 'yes'),
            assessmentOffsetScheme: this.ObligationPaymentId == 0 ? '' : response.assessmentOffsetScheme,            
            nswReference: this.ObligationPaymentId == 0 ? this.quote.nswobligationReference : response.nswStatutoryObligationReference,
            commonWealthReference: this.ObligationPaymentId == 0 ? this.quote.commonwealthObligationReference : response.commonwealthObligationReference,
          });
          
        });
      }
      });
      
  }

  private setDevelopmentDetails(): void {
    //console.log("selectedObligationPayment: ", this.selectedObligationPayment);
  const applicantId = Number(this.selectedObligationPayment?.applicantId || 0);
  const fallbackApplicant: any = this.quote?.applicant || null;
  //console.log("Setting development details for applicantId: ", applicantId, " with fallback: ", fallbackApplicant);   
  if (applicantId > 0) {
    this.quoteService.getApplicant(applicantId).subscribe(
      (applicantData: any) => {
        this.applyApplicantDetails(applicantData || fallbackApplicant);
      },
      () => {
        this.applyApplicantDetails(fallbackApplicant);
      }
    );
    return;
  }

  this.applyApplicantDetails(fallbackApplicant);
}

private applyApplicantDetails(applicant: any): void {
  const applicantData = applicant || {};
  const applicantContacts: any[] = applicantData?.contacts || [];
 
  let authOption = this.selectedObligationPayment?.authorisationOption ? this.selectedObligationPayment.authorisationOption : this.quote?.authorisationOption ? this.quote.authorisationOption : "self";
//console.log("this.quote.obligationType:", this.quote.obligationType); 
  this.fgQuote.patchValue({
    name: applicantData?.firstName || '',
    organisation: applicantData?.company || '',
    applicantType: applicantData?.subType ? applicantData.subType : '',
    abn: applicantData?.abn || '',

    authOption: authOption == "self" ? "self" : "autho",
    authName: this.selectedObligationPayment?.authoriserName ? 
              this.selectedObligationPayment.authoriserName : 
              this.quote.authoriserName ? this.quote.authoriserName : '',

    authOrganisation: this.selectedObligationPayment?.authoriserOrganisation ? 
                      this.selectedObligationPayment.authoriserOrganisation : 
                      this.quote.authoriserOrganisation ? this.quote.authoriserOrganisation : '',

    developmentName: this.selectedObligationPayment?.projectName ? this.selectedObligationPayment.projectName : this.quote.developmentName ? this.quote.developmentName : "",
    developmentType: this.selectedObligationPayment?.developmentType
      ? this.getDevelopmentTypeId(this.selectedObligationPayment.developmentType)
      : this.quote.developmentTypeId ? this.quote.developmentTypeId : '',
      
    lga: this.selectedObligationPayment?.localGovernmentArea
      ? this.selectedObligationPayment.localGovernmentArea
      : this.quote?.lga ? this.quote.lga : this.quote?.lgaid ? this.getLGA(this.quote.lgaid) : '',
    
    offsetType: this.selectedObligationPayment?.statutoryObligationType
      ? this.selectedObligationPayment.statutoryObligationType
      : this.quote.obligationType ? this.getOffsetTypeValue(this.quote.obligationType) : "",

  });

  this.patchApplicationDetailFields();
  this.updateAbnValidators();

  const applicantAddress = applicantData?.addresses?.[0];
  //console.log("Applicant details patched: ", applicantAddress);
  if (applicantAddress) {
    this.applicantMailingAddress?.setAddress(applicantAddress as any);
  } else {
    this.applicantMailingAddress?.resetForm();
  }

  this.applicantContact?.patchValue(null as any);
  this.secondaryContact?.patchValue(null as any);

  if (applicantContacts[0]) {
    this.applicantContact?.patchValue(applicantContacts[0]);
  }

  if (applicantContacts[1]) {
    this.secondaryContact?.patchValue(applicantContacts[1]);
  }

  this.applicantContact.readonly = this.viewMode;
  this.secondaryContact.readonly = this.viewMode;
}

  private patchApplicationDetailFields(response?: any): void {
    const isDraftOrExistingPayment = this.ObligationPaymentId !== 0;
    const selectedPayment = this.selectedObligationPayment || {};
    const nswApprovalAuthority = response?.nswApprovalAuthority
      ?? selectedPayment?.nswApprovalAuthority
      ?? '';

    const nswApprovalDateValue = response?.nswApprovalDate
      ?? selectedPayment?.nswApprovalDate
      ?? '';
    const nswApprovalDate = nswApprovalDateValue
      ? nswApprovalDateValue.toString().slice(0, 10)
      : '';
    const assessmentOffsetScheme = isDraftOrExistingPayment
      ? (response?.assessmentOffsetScheme ?? selectedPayment?.assessmentOffsetScheme ?? '')
      : '';

    const nswReference = isDraftOrExistingPayment
      ? (response?.nswStatutoryObligationReference
        ?? selectedPayment?.nswStatutoryObligationReference
        ?? this.quote?.nswobligationReference
        ?? '')
      : (this.quote?.nswobligationReference ?? '');

    const commonWealthReference = isDraftOrExistingPayment
      ? (response?.commonwealthObligationReference
        ?? selectedPayment?.commonwealthObligationReference
        ?? this.quote?.commonwealthObligationReference
        ?? '')
      : (this.quote?.commonwealthObligationReference ?? '');

    this.fgQuote.patchValue({
      nswApprovalAuthority: nswApprovalAuthority,
      nswApprovalDate: nswApprovalDate,
      assessmentOffsetScheme: assessmentOffsetScheme,
      nswReference: nswReference,
      commonWealthReference: commonWealthReference,
    });
  }

  private syncApplicantControlState(): void {
    this.applicantFieldControlNames.forEach((name: string) => {
      const control = this.fgQuote?.get(name);
      if (!control) {
        return;
      }

      if (this.viewMode) {
        control.disable({ emitEvent: false });
        return;
      }

      control.enable({ emitEvent: false });
    });
  }

  private syncDevelopmentControlState(): void {
    const developmentFieldControlNames: string[] = ['developmentName', 'developmentType', 'lga', 'offsetType'];

    developmentFieldControlNames.forEach((name: string) => {
      const control = this.fgQuote?.get(name);
      if (!control) {
        return;
      }

      if (this.viewMode) {
        control.disable({ emitEvent: false });
        return;
      }

      control.enable({ emitEvent: false });
    });
  }

  private setPayerDetails(): void {
    const payerId = this.payerApplicantId ?? null;
    const applicantId = this.selectedObligationPayment?.applicantId ?? this.quote?.applicant?.id ?? null;
    //console.log("Setting payer details for payerId: ", payerId, " and applicantId: ", applicantId);
    if (!payerId || payerId === applicantId) {
      this.payerApplicantId = 0;
      this.payerContactId = 0;
      this.payerAddressId = 0;
      this.fgQuote.patchValue({
        isPayerSameAsApplicant: 'yes',
        payerName: '',
        payerType: '',
        payerABN: '',
      });
      return;
    }

    this.quoteService.getApplicant(payerId).subscribe((payer: any) => {
      //console.log("Payer details: ", payer);
      this.fgQuote.patchValue({
        isPayerSameAsApplicant: 'no',
        payerName: payer?.firstName || '',
        payerType: payer?.subType || '',
        payerABN: payer?.abn || '',
      });

      if (payer) {
        const payerContact = payer.contacts.find((c: any) => c.type === 'P') || payer.contacts[0];
        const payerContactId = Number(payerContact?.id ?? payerContact?.contactId ?? payerContact?.applicantContactId ?? 0);
        this.payerContactId = Number.isFinite(payerContactId) && payerContactId > 0 ? payerContactId : this.payerContactId;
        //console.log("Payer contact: ", payerContact);

        const payerAddress = payer?.addresses?.find((a: any) => a.type === 'P') || payer?.addresses[0];
        const payerAddressId = Number(payerAddress?.id ?? payerAddress?.addressId ?? payerAddress?.applicantAddressId ?? 0);
        this.payerAddressId = Number.isFinite(payerAddressId) && payerAddressId > 0 ? payerAddressId : this.payerAddressId;
        //console.log("Payer address: ", payerAddress, "resolvedAddressId:", this.payerAddressId);

        setTimeout(() => {
          if (payerContact) {
            this.payerContact.patchValue({ ...payerContact, id: this.payerContactId || 0 });
          }

          if (payerAddress) {
            this.payerMailingAddress.patchValue({
              id: this.payerAddressId || 0,
              address1: payerAddress.address1 || '',
              suburb: payerAddress.suburb || '',
              state: payerAddress.state || '',
              postCode: payerAddress.postCode || '',
              country: payerAddress.country || '',
              type: payerAddress.type
            });
          }
        });
      }
    });
  }

  public onPayerSameAsApplicantChange(value: string): void {
    if (value === 'yes') {
      this.payerContactId = 0;
      this.payerAddressId = 0;

      this.fgQuote.patchValue({
        payerName: '',
        payerType: '',
        payerABN: '',
      });

      setTimeout(() => {
        this.payerContact?.patchValue(null as any);
        this.payerMailingAddress?.resetForm();
      });
      return;
    }

    if (value === 'no') {
      if ((this.payerApplicantId || 0) > 0 ) {
        this.setPayerDetails();
        return;
      }

    }
  }

  private getDevelopmentType(typeId: number): string {
    const developmentType = this.developmentTypes.find(x => x.id == typeId);
    if (developmentType) return developmentType.name;
    return "";
  }

  private getLGA(typeId: number): string {
    const lga = this.lgas.find(x => x.id == typeId);
    if (lga) return lga.name;
    return "";
  }

  private getApplicantType(type: string): string {
    if (type == "BUS") return "Business";
    if (type == "IND") return "Individual";
    if (type == "LGOV") return "Local Government";
    if (type == "PART") return "Partnership ";
    if (type == "SGOV") return "State Government";
    if (type == "TST") return "Trust";

    return "";
  }


  loadDocuments(id: number) {
    this.quoteService.getDocuments(id).subscribe(result => {
      this.documents = result;

      if (this.documents) {
        this.documents.forEach(item => {

          if (item.fileTypeName == "Equivalence statement") {
            this.QFEQSFile = item.name;
          }

          if (item.fileTypeName == "NSW development application") {
            this.QFNSWDEVFile = item.name;
            this.nswDevApplicationSubmitted = true;
          }

          if (item.fileTypeName == "NSW statutory approval with offset conditions") {
            this.QFNSWAPRFile = item.name;
            this.statutoryUploaded = true;
          }

          if (item.fileTypeName == "Commonwealth statutory consent with offset conditions") {
            this.QFCWAPRFile = item.name;
            this.commonWealthUploaded = true;
          }

          if (item.fileTypeName == "Credit report") {
            this.QFCRFile = item.name;
            this.creditReportUploaded = true;
          }

        });
      }

    });
  }

  loadQuoteStatement(id: number) {
    let result: Observable<any>;
    let totalPrice = 0;
    this.hasAppliedInitialGridTotals = false;
    const validPaymentId = Number(this.paymentId);
    
    if (this.viewMode && Number.isFinite(validPaymentId) && validPaymentId > 0) 
      result = this.quoteService.getQuoteStatementForPaymentById(id, validPaymentId); //try using payment id
    else if (this.paymentNumber != '' && this.viewMode)
      result = this.quoteService.getQuoteStatementForPayment(id, this.paymentNumber); //try using payment number
    else
      result = this.quoteService.getQuoteStatement(id);

    result.pipe(map((result) => {
            this.creditStatement = result;
            return result;
    })).pipe(map((response) => {
        return response.credits.map(credit => {
          var res: any = {};
          res.id = credit.id;
          res.referenceNumber = credit.referenceNumber;
          res.ibraSubregion = credit.credit.ibraSubregion;
          res.creditCategory = credit.credit.creditCategory;
          res.creditTypeId = credit.credit.creditTypeId;
          res.offsetTradingGroup = credit.credit.offsetTradingGroup;
          res.hbt = credit.credit.hbt;
          res.totalCredits = credit.credit.totalCredits;
          res.creditsToPay = credit.credit.totalCredits;
          res.selected = false;

          res.isTec = credit.credit.isTec;
          res.tradingGroupId = credit.credit.tradingGroupId;
          res.commonwealthOffset = credit.commonwealthOffset;
          res.monthlyIndexation = credit.monthlyIndexation ? credit.monthlyIndexation : 0;
          res.indexationPerCredit = credit.indexationPerCredit ? credit.indexationPerCredit : 0;
          res.monthsLapsed = credit.monthsLapsed;
          res.formation = credit.credit.formation;
          res.bvtId = credit.credit.BvtId;
          res.speciesType = credit.credit.speciesType;
          res.vegetationClass = credit.credit.vegetationClass;
          res.pctCleared = credit.credit.pctCleared;
          res.ibraId = credit.credit.IbraId;
          res.IbraSubId = credit.credit.IbraSubId;
          res.expiryDate = credit.expiryDate;

          res.predictedPrice = 0;
          res.riskPremium = 0;
          res.deliveryFee = 0;
          res.calculationMethod = "";
          res.obligationPaymentPerCredit = 0;
          res.paymentPerCredit = 0;


          if (credit.price) {
            totalPrice +=credit.price.predictedPrice;
            res.predictedPrice = credit.price.predictedPrice;
            res.riskPremium = credit.price.riskPremium;
            res.deliveryFee = credit.price.deliveryFee;
            res.calculationMethod = credit.price.calculationMethod;
              res.externalFeePerCredit = credit.price.externalFeePerCredit ? credit.price.externalFeePerCredit : 0;
          }

            res.obligationPaymentExcludingFeesPerCredit = res.predictedPrice + res.riskPremium;

          res.obligationPaymentPerCredit = credit.obligationPaymentPerCredit;
          res.paymentPerCredit = credit.totalObligation;
          res.convertedToObligation = credit.convertedToObligation;
          res.paymentReferenceNo = credit.paymentReferenceNo;
          return res;
        });
      })).subscribe(result => {
        this.obligationData = result;
        
        if(totalPrice == 0)
          this.helperService.toasterService.info("Atleast one obligation should have valid price");

        // Apply months lapsed recalculation now that obligation data is available.
        const currentMonths = this.fgQuote.get('monthsLapsed')?.value;
        if (this.obligationData.length > 0 && (this.isRFQAfterAmendment || (currentMonths !== '' && currentMonths != null))) {
          this.updateObligationPaymentPerCredit(currentMonths === '' || currentMonths == null ? 0 : currentMonths);
        }

        setTimeout(() => this.applyInitialGridTotalsOnce(), 100);
      });
  }

  private updateObligationPaymentPerCredit(monthsLapsed: number | string): void {

    if (this.obligationData.length == 0)
      return;
    //console.log("Updating obligation payment " , this.obligationData);
    const monthsLapsedValue = Number(monthsLapsed) || 0;

    this.fgQuote.patchValue({
      monthsLapsed: monthsLapsedValue.toString()
    });

    this.obligationData.forEach(item => {
      let predictedPrice = item.predictedPrice ? item.predictedPrice : 0;
      let riskPremium = item.riskPremium ? item.riskPremium : 0;
      let deliveryFee = item.deliveryFee ? item.deliveryFee : 0;
      let monthlyIndexation = item.monthlyIndexation ? item.monthlyIndexation : 0;
      let externalFeePerCredit = item.externalFeePerCredit ? item.externalFeePerCredit : 0;

      item.obligationPaymentExcludingFeesPerCredit = predictedPrice + riskPremium;
      let obligationPaymentPerCredit = this.isRFQAfterAmendment
        ? item.obligationPaymentExcludingFeesPerCredit + deliveryFee + externalFeePerCredit
        : item.obligationPaymentExcludingFeesPerCredit + deliveryFee + (monthlyIndexation * monthsLapsedValue);

        //console.log('payment', obligationPaymentPerCredit);
      item.obligationPaymentPerCredit = obligationPaymentPerCredit;
      item.paymentPerCredit = obligationPaymentPerCredit * item.creditsToPay;
      item.monthsLapsed = monthsLapsedValue;
    });

    if (this.gridApi) {
      this.gridApi.refreshCells({ force: true });
    }

    //this.updateTotal();
    this.setPaymentGridPinnedTotalRow();
  }


  loadPaymentStatement(id: number) {
    let result: Observable<any>;
    let totalPrice = 0;
    result = this.quoteService.getStatementForPayment(id,this.paymentId);
    
    result.pipe(map((result) => {
            this.creditStatement = result;
            return result;
    })).pipe(map((response) => {
        return response.credits.map(credit => {
          var res: any = {};
          res.id = credit.id;
          res.referenceNumber = credit.paymentReferenceNo;
          res.ibraSubregion = credit.credit.ibraSubregion;
          res.creditCategory = credit.credit.creditCategory;
          res.creditTypeId = credit.credit.creditTypeId;
          res.offsetTradingGroup = credit.credit.offsetTradingGroup;
          res.hbt = credit.credit.hbt;
          res.totalCredits = credit.credit.totalCredits;
          res.creditsToPay = credit.credit.totalCredits;

          res.isTec = credit.credit.isTec;
          res.tradingGroupId = credit.credit.tradingGroupId;
          res.commonwealthOffset = credit.commonwealthOffset;
          res.monthlyIndexation = credit.monthlyIndexation ? credit.monthlyIndexation : 0;
          res.monthsLapsed = credit.monthsLapsed;
          res.formation = credit.credit.formation;
          res.bvtId = credit.credit.BvtId;
          res.speciesType = credit.credit.speciesType;
          res.vegetationClass = credit.credit.vegetationClass;
          res.pctCleared = credit.credit.pctCleared;
          res.ibraId = credit.credit.IbraId;
          res.IbraSubId = credit.credit.IbraSubId;
          res.expiryDate = credit.expiryDate;

          res.predictedPrice = 0;
          res.riskPremium = 0;
          res.deliveryFee = 0;
          res.calculationMethod = "";
          res.obligationPaymentPerCredit = 0;
          res.paymentPerCredit = 0;


          if (credit.price) {
            totalPrice +=credit.price.predictedPrice;
            res.predictedPrice = credit.price.predictedPrice;
            res.riskPremium = credit.price.riskPremium;
            res.deliveryFee = credit.price.deliveryFee;
            res.calculationMethod = credit.price.calculationMethod;
          }

          res.obligationPaymentPerCredit = credit.obligationPaymentPerCredit;
          res.paymentPerCredit = credit.totalObligation;
          res.convertedToObligation = credit.convertedToObligation;
          res.paymentReferenceNo = credit.paymentReferenceNo;
          return res;
        });
      })).subscribe(result => {
        this.obligationData = result;
        setTimeout(() => this.setPaymentGridPinnedTotalRow(), 100);
      });
   
  }

  private getIncludedObligationRows(): any[] {
    const rows = Array.isArray(this.obligationData) ? this.obligationData : [];
    const selectedRows = rows.filter((item: any) => item?.selected === true);
    return this.viewMode || selectedRows.length === 0 ? rows : selectedRows;
  }

  private setPaymentGridPinnedTotalRow(): void {
    const result: any[] = [];
    const includedRows = this.getIncludedObligationRows();
    const includedRowSet = new Set(includedRows);
    const hasIncludedRows = includedRows.length > 0;
    const fixedFee = hasIncludedRows ? this.bcfPaymentFee : 0;
    let gst = 0.10;

    if (this.isRFQAfterAmendment) {
      let totalPriceExclFee = 0;
      let totalDeliveryFeeExclGst = 0;
      let externalFeeTotal = 0;
           
      (this.obligationData || []).forEach((credit: any) => {
        const creditsForPayment = Number(credit?.creditsToPay ?? credit?.totalCredits ?? 0);
        const predictedPrice = Number(credit?.predictedPrice ?? 0);
        const riskPremium = Number(credit?.riskPremium ?? 0);
        const deliveryFee = Number(credit?.deliveryFee ?? 0);
        const externalFeePerCredit = Number(credit?.externalFeePerCredit ?? 0);
        const deliveryFeePerCredit = (credit?.deliveryFee != null ? credit.deliveryFee : 0);
        
        credit.externalFeePerCredit = externalFeePerCredit;
        credit.deliveryFee = deliveryFeePerCredit;
        credit.totalpredictedPrice = creditsForPayment * predictedPrice;
        credit.totalRiskPremium = creditsForPayment * riskPremium;

        credit.totalPriceExclFee = credit.totalpredictedPrice + credit.totalRiskPremium;
        credit.totalExternalFee = creditsForPayment * externalFeePerCredit;
        credit.totalDeliveryFee = creditsForPayment * deliveryFeePerCredit;
        credit.totalPayment = credit.totalPriceExclFee + credit.totalExternalFee + credit.totalDeliveryFee;
        credit.bcfPaymentFee = this.bcfPaymentFee;

        if (includedRowSet.has(credit)) {
          totalPriceExclFee += Number(credit?.totalPriceExclFee ?? 0);
          totalDeliveryFeeExclGst += Number(credit?.totalDeliveryFee ?? 0);
          externalFeeTotal += Number(credit?.totalExternalFee ?? 0);
        }
      });
     

      const totalPaymentExclFeeGst = Helper.roundAwayFromZero(totalPriceExclFee * gst,2);
      const totalPaymentExclFeeInclGst = totalPriceExclFee + totalPaymentExclFeeGst;

      const totalDeliveryFeeGst = Helper.roundAwayFromZero((totalDeliveryFeeExclGst + fixedFee) * gst, 2);
      const totalDeliveryFeeInclGst = totalDeliveryFeeExclGst + totalDeliveryFeeGst;

      const totalExternalFeeGst = 0;
      const totalExternalFeeInclGst = externalFeeTotal + totalExternalFeeGst;

      const fixedFeeRow = {
        referenceNumber: 'Delivery cost - Fixed fee',
        totalPriceExclFee: 0,
        totalDeliveryFee: fixedFee,
        totalExternalFee: 0,
        totalPayment: fixedFee
      };

      const totalWithoutGstRow = {
        referenceNumber: 'Total payment (Excluding GST)',
        totalPriceExclFee: totalPriceExclFee,
        totalDeliveryFee: totalDeliveryFeeExclGst + fixedFee,
        totalExternalFee: externalFeeTotal,
        totalPayment: totalPriceExclFee + totalDeliveryFeeExclGst + externalFeeTotal + fixedFee
      };

      const totalGstRow = {
        referenceNumber: 'Total GST',
        totalPriceExclFee: totalPaymentExclFeeGst,
        totalDeliveryFee: totalDeliveryFeeGst,
        totalExternalFee: totalExternalFeeGst,
        totalPayment: totalPaymentExclFeeGst + totalDeliveryFeeGst + totalExternalFeeGst
      };

      const totalWithGstRow = {
        referenceNumber: 'Total payment (Including GST)',
        totalPriceExclFee: totalPaymentExclFeeInclGst,
        totalDeliveryFee: totalDeliveryFeeInclGst + fixedFee,
        totalExternalFee: totalExternalFeeInclGst,
        totalPayment: totalPaymentExclFeeInclGst + totalDeliveryFeeInclGst + fixedFee + totalExternalFeeInclGst
      };

      result.push(fixedFeeRow);
      result.push(totalWithoutGstRow);
      result.push(totalGstRow);
      result.push(totalWithGstRow);

      this.pinnedTotalRowData = result;

    } else {
      
      //console.log("Calculating total payment for non-amendment RFQ", this.obligationData);

      const totalPaymentExcludingGst = includedRows.reduce((sum: number, item: any) => {
        const amount = Number(item?.paymentPerCredit ?? 0);
        return sum + (Number.isFinite(amount) ? amount : 0);
      }, 0);
      const totalGst = Helper.roundAwayFromZero(totalPaymentExcludingGst * gst, 2);
      const totalPaymentIncludingGst = totalPaymentExcludingGst + totalGst;

      result.push({
        referenceNumber: 'Total (Exc. GST)',
        paymentPerCredit: totalPaymentExcludingGst
        
      });

      result.push({
        referenceNumber: 'GST',
        paymentPerCredit: totalGst
      });

      result.push({
        referenceNumber: 'Total (Inc. GST)',
        paymentPerCredit: totalPaymentIncludingGst
      });
    }

     this.pinnedTotalRowData = result;

    /*if (this.gridApi) {
      this.gridApi.setPinnedBottomRowData(this.totalPinnedBottomRowData);
    }*/
  }


  private updateTotal(): void {
    let totalPrice: number = 0;
    let externalFee: number = 0;
    const includedRows = this.getIncludedObligationRows();

    includedRows.forEach((item: any) => {
      const payment = Number(item?.paymentPerCredit ?? 0);
      const externalFeePerCredit = Number(item?.externalFeePerCredit ?? 0);
      const creditsToPay = Number(item?.creditsToPay ?? 0);
      totalPrice += Number.isFinite(payment) ? payment : 0;
      externalFee += Number.isFinite(externalFeePerCredit * creditsToPay)
        ? externalFeePerCredit * creditsToPay
        : 0;
    });

    if(this.isRFQAfterAmendment){
      this.creditStatement.totalPaymentExcludingGST = totalPrice - externalFee;
      const fixedFee = includedRows.length > 0 ? this.bcfPaymentFee : 0;
      this.creditStatement.gstAmount = Helper.roundAwayFromZero((this.creditStatement.totalPaymentExcludingGST + fixedFee) * this.creditStatement.gst, 2);
      this.creditStatement.totalPaymentIncludingGST = totalPrice + fixedFee + this.creditStatement.gstAmount;
    }else{
      this.creditStatement.totalPaymentExcludingGST = totalPrice;
      this.creditStatement.gstAmount = Helper.roundAwayFromZero(totalPrice * this.creditStatement.gst, 2);
      this.creditStatement.totalPaymentIncludingGST = totalPrice + this.creditStatement.gstAmount;
    }
    this.setPaymentGridPinnedTotalRow();
  }


  public saveContact() {
    if (!this.quote && this.quote.id <= 0)
      return;
  }

  fileSelected($event: any, index: number) {

    const file: File = $event.target.files[0];
    switch (index) {
      case 1:
        this.fileNSW1 = file;
        break;
      case 2:
        this.fileNSW2 = file;
        break;
      case 3:
        this.fileCW = file;
        break;
      case 4:
        this.fileCR = file;
        break;
      case 5:
        this.fileES = file;
        break;
    }
  }

  public updateContacts() {
    var contactrequest: any = {};
    var contacts = [];

    contacts.push(this.applicantContact.getContact());
    contacts.push(this.secondaryContact.getContact());
   
    contacts.forEach(item => item.applicantId = this.quote.applicantId);
    contactrequest.contacts = contacts;

    this.quoteService.updateApplicantContact(contactrequest, this.quote.applicantId).subscribe(res => {
      this.helperService.toasterService.success("Details updated successfully.");
    });

  }

  private buildPayerPayload(): any {
    if (this.fgQuote.value.isPayerSameAsApplicant === 'yes') return null;

    const payerContact: any = this.payerContact?.formValue;
    const payerMailingAddress = this.payerMailingAddress?.formValue;

    //console.log("Building payer payload with contact: ", payerContact, "and mailing address: ", payerMailingAddress);

    const contacts = payerContact
      ? [{ ...payerContact, id: Number(payerContact.id) || this.payerContactId || 0 }]
      : [];

    contacts.forEach((item: any) => item.applicantId = this.quote.applicantId);

    const addresses = payerMailingAddress
      ? [{ ...payerMailingAddress, id: Number(payerMailingAddress.id) || this.payerAddressId || 0 }]
      : [];

    const payer = {
      id: this.payerApplicantId || 0,
      firstName: this.fgQuote.value.payerName,
      subType: this.fgQuote.value.payerType,
      abn: this.fgQuote.value.payerABN,
      contacts: contacts,
      addresses: addresses,
    };

    if (payer.contacts) {
      payer.contacts.forEach((contact: any) => {
        contact.applicantId = this.payerApplicantId || 0;
        contact.type = CONTACT_TYPES.PRIMARY_CONTACT;
      });
    }

    if (payer.addresses) {
      payer.addresses.forEach((address: any) => {
        address.applicantId = this.payerApplicantId || 0;
        address.type = ADDRESS_TYPES.PAYER;
      });
    }
    //console.log("Payer details: ", payer);
    return payer;
  }

  private normalizeForCompare(value: any): string {
    return (value ?? '').toString().trim();
  }

  private valueOrNull(value: any): any {
    const normalized = this.normalizeForCompare(value);
    return normalized === '' ? null : normalized;
  }

  private isChanged(currentValue: any, originalValue: any): boolean {
    return this.normalizeForCompare(currentValue) !== this.normalizeForCompare(originalValue);
  }

  private getPrimaryContact(contacts: any[]): any {
    if (!contacts || contacts.length === 0) return null;
    return contacts.find((c: any) => c?.type === CONTACT_TYPES.PRIMARY_CONTACT || c?.type === 'P') || contacts[0];
  }

  private getSecondaryContact(contacts: any[]): any {
    if (!contacts || contacts.length === 0) return null;
    return contacts.find((c: any) => c?.type === CONTACT_TYPES.SECONDARY_CONTACT || c?.type === 'S') || null;
  }

  private hasContactChanges(currentContact: any, originalContact: any): boolean {
    return this.isChanged(currentContact?.firstName, originalContact?.firstName)
      || this.isChanged(currentContact?.lastName, originalContact?.lastName)
      || this.isChanged(currentContact?.phone, originalContact?.phone)
      || this.isChanged(currentContact?.mobile, originalContact?.mobile)
      || this.isChanged(currentContact?.email, originalContact?.email)
      || this.isChanged(currentContact?.fax, originalContact?.fax)
      || this.isChanged(currentContact?.type, originalContact?.type);
  }

  private mapContactPayload(applicantId: number, currentContact: any, originalContact: any, fallbackType: string): any {
    return {
      id: Number(currentContact?.id || originalContact?.id || 0),
      firstName: this.valueOrNull(currentContact?.firstName),
      lastName: this.valueOrNull(currentContact?.lastName),
      phone: this.valueOrNull(currentContact?.phone),
      mobile: this.valueOrNull(currentContact?.mobile),
      email: this.valueOrNull(currentContact?.email),
      fax: this.valueOrNull(currentContact?.fax),
      type: this.valueOrNull(currentContact?.type || originalContact?.type || fallbackType),
      applicantId: applicantId
    };
  }

  private buildApplicantContactsPayload(
    applicantId: number,
    currentPrimaryContact: any,
    originalPrimaryContact: any,
    currentSecondaryContact: any,
    originalSecondaryContact: any
  ): any[] | null {
    
    const primaryChanged = this.hasContactChanges(currentPrimaryContact, originalPrimaryContact);
    const hasSecondaryContact = (currentSecondaryContact?.firstName ?? '').toString().trim() !== '';
    //const secondaryChanged = hasSecondaryContact && this.hasContactChanges(currentSecondaryContact, originalSecondaryContact);
    const secondaryChanged = this.hasContactChanges(currentSecondaryContact, originalSecondaryContact);

    if (!primaryChanged && !secondaryChanged) {
      return null;
    }

    // Backend replaces all contacts with what's sent, so both must be included
    // whenever either one changes, otherwise the untouched contact is lost.
    const contacts: any[] = [
      this.mapContactPayload(applicantId, currentPrimaryContact, originalPrimaryContact, CONTACT_TYPES.PRIMARY_CONTACT)
    ];

    if (hasSecondaryContact) {
      contacts.push(this.mapContactPayload(applicantId, currentSecondaryContact, originalSecondaryContact, CONTACT_TYPES.SECONDARY_CONTACT));
    }

    return contacts.length > 0 ? contacts : null;
  }

  private hasAddressChanges(currentAddress: any, originalAddress: any): boolean {
    return this.isChanged(currentAddress?.address1, originalAddress?.address1)
      || this.isChanged(currentAddress?.suburb, originalAddress?.suburb)
      || this.isChanged(currentAddress?.state, originalAddress?.state)
      || this.isChanged(currentAddress?.postCode, originalAddress?.postCode)
      || this.isChanged(currentAddress?.country, originalAddress?.country)
      || this.isChanged(currentAddress?.type, originalAddress?.type);
  }

  private buildApplicantPayload(): any {
    const applicantId = Number(this.selectedObligationPayment?.applicantId || 0);
    const existingApplicant: any = this.quote?.applicant || {};
    const existingContacts: any[] = existingApplicant?.contacts || [];
    const existingPrimaryContact = this.getPrimaryContact(existingContacts);
    const existingSecondaryContact = this.getSecondaryContact(existingContacts);
    const existingAddress: any = existingApplicant?.addresses?.[0] || {};
    const applicantMailingAddress = this.applicantMailingAddress?.formValue ;
    const currentPrimaryContact: any = this.applicantContact?.formValue || {};
    const currentSecondaryContact: any = this.secondaryContact?.formValue || {};

    const applicantCoreChanged = this.isChanged(this.fgQuote.value.name, existingApplicant?.firstName)
      || this.isChanged(this.fgQuote.value.applicantType, existingApplicant?.subType)
      || this.isChanged(this.fgQuote.value.abn, existingApplicant?.abn);

    const contacts = this.buildApplicantContactsPayload(
      applicantId,
      currentPrimaryContact,
      existingPrimaryContact,
      currentSecondaryContact,
      existingSecondaryContact
    );

    const addresses = this.hasAddressChanges(applicantMailingAddress, existingAddress)
      ? [{
          id: Number(applicantMailingAddress?.id || existingAddress.id || 0),
          address1: this.valueOrNull(applicantMailingAddress?.address1),
          suburb: this.valueOrNull(applicantMailingAddress?.suburb),
          state: this.valueOrNull(applicantMailingAddress?.state),
          postCode: this.valueOrNull(applicantMailingAddress?.postCode),
          country: this.valueOrNull(applicantMailingAddress?.country || existingAddress.country),
          type: this.valueOrNull(applicantMailingAddress?.type || existingAddress.type),
          applicantId: applicantId
        }]
      : null;

    if (!applicantCoreChanged && contacts == null && addresses == null) {
      return null;
    }

    return {
      id: applicantId,
      firstName: this.valueOrNull(this.fgQuote.value.name),
      subType: this.valueOrNull(this.fgQuote.value.applicantType),
      abn: this.valueOrNull(this.fgQuote.value.abn),
      contacts: contacts,
      addresses: addresses,
    };
  }

  public update() {
    if (!this.canUpdate() || !this.validatePayer(true) || !this.validateApplicant(true) || !this.validateDevelopment(true)) {
      return;
    }

    //this.updateContacts();
    const request: any = {
      ObligationPaymentId:this.ObligationPaymentId,

      DevelopmentName: this.fgQuote.value.developmentName ? this.fgQuote.value.developmentName : "",
      DevelopmentType: this.fgQuote.value.developmentType ? this.getDevelopmentType(Number(this.fgQuote.value.developmentType)) : "",
      LGA: this.fgQuote.value.lga ? this.fgQuote.value.lga : "",
      
      NSWApprovalType : this.fgQuote.value.offsetType,
      NSWApprovalAuthority: this.fgQuote.value.nswApprovalAuthority,
      NSWApprovalDate: this.fgQuote.value.nswApprovalDate,
      NSWStatutoryObligationReference: this.fgQuote.value.nswReference,
      
      AssessmentOffsetScheme: this.fgQuote.value.assessmentOffsetScheme,
      commonwealthObligationReference: this.fgQuote.value.commonWealthReference,

      applicant: this.buildApplicantPayload(),
      payer: this.buildPayerPayload()
    }

    this.quoteService.updateRTMPDevelopmentDetails(this.quote.id, request).subscribe(res => {
      this.helperService.toasterService.success("RTMP application details updated successfully.");
    });

  }

  public updateApplicantDetails(){
     const applicantId =  this.quote.applicantId;
    const request:any = {     
      abn : this.fgQuote.value.abn,
      poBox: this.fgQuote.value.poBox,
      suburb: this.fgQuote.value.suburb,
      state: this.fgQuote.value.state,
      postCode: this.fgQuote.value.postCode
    }
    this.quoteService.updateApplicantDetails(request,applicantId).subscribe(res => {
      this.helperService.toasterService.success("Application details updated successfully.");
    });
  }

  public saveDraft() {
    if (!this.canSaveDraft() || !this.validatePayer(true) || !this.validateDevelopment(true)) {
      return;
    }

    this.checkAndGetPaymentNo();
  }

  public checkAndGetPaymentNo() {

    if (!this.validateApplicant(true)) {
      return;
    }

    if (!this.validatePayer(true)) {
      return;
    }

    if (!this.validateDevelopment(true)) {
      return;
    }

    var convertRequest: any = {};
    var existingPaymentuNumbers = this.fgQuote.controls['bcfPaymentNumber'].value;

    convertRequest.quoteId = this.quote.id;
    convertRequest.applicantId = this.quote.applicant.id;
    convertRequest.authorisationOption = this.quote.authorisationOption;
    convertRequest.status = "DRAFT"; //be default it will be in draft status

    convertRequest.developmentName = this.fgQuote.value.developmentName ? this.fgQuote.value.developmentName : "";
    convertRequest.developmentType = this.fgQuote.value.developmentType ? this.getDevelopmentType(Number(this.fgQuote.value.developmentType)) : "";
    convertRequest.lga = this.fgQuote.value.lga ? this.fgQuote.value.lga : "";
    convertRequest.nswApprovalType = this.fgQuote.value.offsetType;
    convertRequest.nswApprovalAuthority = this.fgQuote.value.nswApprovalAuthority;
    convertRequest.nswApprovalDate = this.fgQuote.value.nswApprovalDate;
    convertRequest.nswStatutoryObligationReference = this.fgQuote.value.nswReference;
    convertRequest.commonwealthObligationReference = this.fgQuote.controls['commonWealthReference'].value;
    convertRequest.assessmentOffsetScheme = this.fgQuote.value.assessmentOffsetScheme;
    convertRequest.applicant = this.buildApplicantPayload();
    convertRequest.payer = this.buildPayerPayload();
  

    this.quoteService.convertToApplication(convertRequest).subscribe(response => {
      if (response) {

        // Handle case where paymentReferenceNumber may or may not contain comma
        if (response.paymentReferenceNumber && response.paymentReferenceNumber.includes(',')) {
          const ref = response.paymentReferenceNumber.split(',');
          this.BCFPaymentReferenceNo = ref.length > 0 ? ref[0].trim() : '';
        } else {
          this.BCFPaymentReferenceNo = response.paymentReferenceNumber || '';
        }
        this.setShapeFileMessage();
        //this.BCFPaymentReferenceNo = response.paymentReferenceNumber;

        this.ObligationPaymentId = response.obligationPaymentId;
        this.applicationStatus = response.status;
        this.helperService.toasterService.success("Draft application saved successfully.");
       
        if(existingPaymentuNumbers.length > 0)
          existingPaymentuNumbers = response.paymentReferenceNumber + "," + existingPaymentuNumbers ;
        else
          existingPaymentuNumbers = response.paymentReferenceNumber

        this.fgQuote.patchValue({
          bcfPaymentNumber: existingPaymentuNumbers 
        });

        //now set the selected payment so subsequent update() calls use the persisted applicant/payer ids instead of creating new ones
        this.quoteService.get(this.quote.id).subscribe(result => {
          if(result.obligationPayments != null && result.obligationPayments.length > 0){
            const matchingPayment = result.obligationPayments.find(payment => 
            payment.id === this.ObligationPaymentId
          );
          this.selectedObligationPayment = matchingPayment;
          this.payerApplicantId = matchingPayment?.payerId ?? this.payerApplicantId;
          }
        }); 

      }
    });
  }

  private updateRequest(id: number, commonwealth: boolean, totalcredits: number) {
    var request: any = {};

    request.id = id;
    request.commonwealthOffset = commonwealth;
    request.totalCredits = +totalcredits;

    const index = this.rtmpUpdateRequest.findIndex(element => element.id === id);

    if (index !== -1) {
      this.rtmpUpdateRequest.splice(index, 1, request);
    } else {
      this.rtmpUpdateRequest.push(request);
    }

  }



  submitRequest() {
    var selected: Array<number> = [];
    var paymentPerCredit = 0;

    this.obligationData.forEach(item => {
      if (item.selected){
        selected.push(item.id);
        const payment = Number(item.paymentPerCredit ?? 0);
        paymentPerCredit += Number.isFinite(payment) ? payment : 0;
      }
    });

    
    //atleat one should be selected to be saved in draft status.
    if (selected.length == 0) {
      this.helperService.toasterService.error(this.validation_obl_error);
      return;
    }

    if(!Number.isFinite(paymentPerCredit) || paymentPerCredit <= 0){
      this.helperService.toasterService.error(this.validation_payment_error);
      return;
    }

    //for each selected obligation data, get the totalcredits and commonwealth, if it has been updated.
    //create request object
    selected.forEach(item => {
      let index = this.obligationData.findIndex(element => element.id === item);
      if (index != -1) {
        this.updateRequest(this.obligationData[index].id, this.obligationData[index].commonwealthOffset, this.obligationData[index].creditsToPay);
      }
    });

    var rtmpRequest: any = {};
    rtmpRequest.id = this.quote.id;
    rtmpRequest.quoteCreditIds = selected;
    rtmpRequest.rtmpUpdateRequests = this.rtmpUpdateRequest;
    rtmpRequest.obligationPaymentId = this.ObligationPaymentId;
    rtmpRequest.PaymentReferenceNo = this.BCFPaymentReferenceNo;
    rtmpRequest.authOption = this.fgQuote.controls['authOption'].value;
    rtmpRequest.authName = this.fgQuote.controls['authName'].value;
    rtmpRequest.authOrganisation = this.fgQuote.controls['authOrganisation'].value;
    rtmpRequest.invoiceRequired = this.invoiceRequired ;
    
    //conirm the sumit
    const modalOptions: NgbModalOptions = {
      size: 'lg'
    };
    const modalRef: NgbModalRef = this.utilityService.openModal('CONFIRMATION_MODAL', 'SUBMIT_RTMP', modalOptions);
    modalRef.result.then((confirm) => {
      //If user selects yes for rtmp
      if (confirm) {
        this.quoteService.rtmp(rtmpRequest,this.quote.id).subscribe(response => {
          //this.helperService.toasterService.success("Application submitted successfully. Payment number is: " + response.paymentReferenceNumber);
          //this.obligationData.length == selected.length ? this.applicationStatus == "SUBMITTED" : this.applicationStatus == "PART_SUBMITTED";
          this.router.navigate(['/rtmp/confirmation'], { 
            state: { paymentReferenceNumber: response.paymentReferenceNumber }
          });        
        });
      }
    });
  }

  consentChanged($event, index: number) {
    if (index == 1) this.consent1 = $event.target.checked
    else this.consent2 = $event.target.checked

  }

  uploadFile(index: number) {
    let file: File;
    const applicationId = this.quote.id;
    let fileTypeId = 0;
    const formData = new FormData();
    let fileType: any = null;
    switch (index) {
      case 1:
        file = this.fileNSW1;
        fileType = this.fileTypes.find(f => f.code == QuoteFileTypes.NSWDevelopmentApplication);
        this.nswDevApplicationSubmitted = true;
        break;
      case 2:
        file = this.fileNSW2;
        fileType = this.fileTypes.find(f => f.code == QuoteFileTypes.NSWDevelopmentApproved);
        this.statutoryUploaded = true;
        break;
      case 3:
        file = this.fileCW;
        fileType = this.fileTypes.find(f => f.code == QuoteFileTypes.CommonwealthApproved);
        this.commonWealthUploaded = true;
        break;
      case 4:
        file = this.fileCR;
        fileType = this.fileTypes.find(f => f.code == QuoteFileTypes.CreditReport);
        this.creditReportUploaded = true;
        break;
      case 5:
        file = this.fileES;
        fileType = this.fileTypes.find(f => f.code == QuoteFileTypes.EquivalenceStatement);
        this.evidenceStatementUploaded = true;
    }

    if (fileType == null) {
      this.helperService.toasterService.error("Invalid file type");
      return;
    }

    fileTypeId = fileType.id;

    if (fileTypeId <= 0) {
      this.helperService.toasterService.error("Invalid file type");
      return;
    }

    //upload file
    formData.append("thumbnail", file);
    formData.append("fileTypeId", fileTypeId.toString());
    //check if draft is saved and payment reference number is generated,if present then upload the file oto RTMP
    if (this.ObligationPaymentId != 0 && this.BCFPaymentReferenceNo !== "") {
      this.fileService.uploadRTMPFile(this.ObligationPaymentId, formData).subscribe(result => {
      });
    }
    else{
     //if not upload to quotes
    this.fileService.uploadFile(applicationId, formData).subscribe(result => {
    });
  }
  }

   openShapeFileModal() {
    const modalRef: NgbModalRef = this.utilityService.openModal('SHAPE_MODAL', '');
    modalRef.componentInstance.UrlString = `${this.mapUrl}?mapfilename=${this.shapeFileLocation}&PaymentNum=${this.BCFPaymentReferenceNo}`;
    modalRef.result.then(
      () => setTimeout(() => this.setShapeFileMessage(), 1000),
      () => setTimeout(() => this.setShapeFileMessage(), 1000)
    );
  }

  private refreshShapeFileStatus(attempt: number = 0): void {
    this.setShapeFileMessage();
  }

  initMapUrl() {
    //console.log(this.configService.mapUrl," location : ", this.configService.shapeFileLocation );

    this.mapUrl = this.configService.mapUrl;
    this.shapeFileLocation = this.configService.shapeFileLocation;
  }

  private validateApplicant(showError: boolean = false): boolean {
    const errors: string[] = [];
    const applicantName = (this.fgQuote.value.name || '').trim();
    const applicantType = (this.fgQuote.value.applicantType || '').trim();
    const applicantABN = (this.fgQuote.value.abn || '').trim();
    const applicantAddress: any = this.applicantMailingAddress?.formValue;
    const poBox = (applicantAddress?.address1 || '').trim();
    const suburb = (applicantAddress?.suburb || '').trim();
    const state = (applicantAddress?.state || '').trim();
    const postCode = (applicantAddress?.postCode || '').trim();
    const applicantNameControl = this.fgQuote.get('name');
    const applicantAbnControl = this.fgQuote.get('abn');
    const addressFormGroup = this.applicantMailingAddress?.formGroup;

    if (showError) {
      applicantNameControl?.markAsTouched();
      applicantAbnControl?.markAsTouched();
      addressFormGroup?.markAllAsTouched();
    }

    if (!applicantName) {
      errors.push('Applicant name is required.');
    }

    if (!applicantType) {
      errors.push('Applicant type is required.');
    }

    if (applicantType !== 'IND' && !applicantABN) {
      errors.push('ABN, ACN or ARBN is required.');
    }

    if (applicantType !== 'IND' && applicantAbnControl?.hasError('invalidAbn')) {
      errors.push(applicantAbnControl.errors?.invalidAbn || 'Invalid ABN.');
    }

    if (!poBox) {
      errors.push('Applicant mailing address is required.');
    }

    if (!suburb) {
      errors.push('Applicant mailing suburb/city is required.');
    }

    if (!state) {
      errors.push('Applicant mailing state/territory is required.');
    }

    if (!postCode) {
      errors.push('Applicant mailing postcode is required.');
    }

    if (this.applicantMailingAddress && !this.applicantMailingAddress.formGroup.valid) {
      errors.push('Applicant mailing address is invalid.');
    }

    const primaryContact: any = this.applicantContact?.formValue;
    const contactFirstName = (primaryContact?.firstName || '').trim();
    const contactEmail = (primaryContact?.email || '').trim();
    const contactPhone = (primaryContact?.phone || '').trim();
    const contactMobile = (primaryContact?.mobile || '').trim();

    if (!contactFirstName) {
      errors.push('Primary contact first name is required.');
    }

    if (!contactEmail) {
      errors.push('Primary contact email is required.');
    }

    if (!contactPhone && !contactMobile) {
      errors.push('Primary contact phone or mobile is required.');
    }

    if (this.applicantContact && !this.applicantContact.isFormValid) {
      errors.push('Primary contact details are invalid.');
    }

    if (errors.length > 0 && showError) {
      this.helperService.toasterService.error(errors[0]);
    }

    return errors.length === 0;
  }

  private validatePayer(showError: boolean = false): boolean {
    if (this.fgQuote.get('isPayerSameAsApplicant')?.value !== 'no') {
      return true;
    }

    const errors: string[] = [];
    const payerName = (this.fgQuote.value.payerName || '').trim();
    const payerType = (this.fgQuote.value.payerType || '').trim();
    const payerABN = (this.fgQuote.value.payerABN || '').trim();
    const payerNameControl = this.fgQuote.get('payerName');
    const payerTypeControl = this.fgQuote.get('payerType');
    const payerAbnControl = this.fgQuote.get('payerABN');

    if (showError) {
      payerNameControl?.markAsTouched();
      payerTypeControl?.markAsTouched();
      payerAbnControl?.markAsTouched();
      this.payerContact?.contactFg?.markAllAsTouched();
      this.payerMailingAddress?.formGroup?.markAllAsTouched();
    }

    if (!payerName) {
      errors.push('Payer name is required.');
    }

    if (!payerType) {
      errors.push('Payer type is required.');
    }

    if (payerType !== 'IND' && !payerABN) {
      errors.push('ABN, ACN or ARBN is required.');
    }

    if (payerAbnControl?.hasError('invalidAbn')) {
      errors.push(payerAbnControl.errors?.invalidAbn || 'Invalid ABN.');
    }

    const payerContact: any = this.payerContact?.formValue;
    const contactFirstName = (payerContact?.firstName || '').trim();
    const contactEmail = (payerContact?.email || '').trim();
    const contactPhone = (payerContact?.phone || '').trim();
    const contactMobile = (payerContact?.mobile || '').trim();

    if (!contactFirstName) {
      errors.push('Payer contact first name is required.');
    }

    if (!contactEmail) {
      errors.push('Payer contact email is required.');
    }

    if (!contactPhone && !contactMobile) {
      errors.push('Payer contact phone or mobile is required.');
    }

    if (this.payerContact && !this.payerContact.isFormValid) {
      errors.push('Payer contact details are invalid.');
    }

    const payerAddress: any = this.payerMailingAddress?.formValue;
    const address1 = (payerAddress?.address1 || '').trim();
    const suburb = (payerAddress?.suburb || '').trim();
    const state = (payerAddress?.state || '').trim();
    const postCode = (payerAddress?.postCode || '').trim();

    if (!address1) {
      errors.push('Payer mailing address is required.');
    }

    if (!suburb) {
      errors.push('Payer mailing suburb/city is required.');
    }

    if (!state) {
      errors.push('Payer mailing state/territory is required.');
    }

    if (!postCode) {
      errors.push('Payer mailing postcode is required.');
    }

    if (errors.length > 0 && showError) {
      this.helperService.toasterService.error(errors[0]);
    }

    return errors.length === 0;
  }

  private validateDevelopment(showError: boolean = false): boolean {
    const errors: string[] = [];
    const requiredDevelopmentFields: Array<{ controlName: string; message: string }> = [
      { controlName: 'developmentName', message: 'Development name is required.' },
      { controlName: 'developmentType', message: 'Development type is required.' },
      { controlName: 'lga', message: 'Local Government Area is required.' },
      { controlName: 'offsetType', message: 'Offset statutory obligation type is required.' },
      { controlName: 'nswApprovalAuthority', message: 'NSW approval authority is required.' },
      { controlName: 'nswApprovalDate', message: 'NSW approval date is required.' },
      { controlName: 'nswReference', message: 'NSW statutory approval no. is required.' },
      { controlName: 'assessmentOffsetScheme', message: 'Assessment offset scheme is required.' },
    ];

    requiredDevelopmentFields.forEach((field) => {
      const control = this.fgQuote.get(field.controlName);
      if (!control || control.disabled) {
        return;
      }

      if (showError) {
        control.markAsTouched();
      }

      const rawValue = control.value;
      const value = typeof rawValue === 'string' ? rawValue.trim() : rawValue;
      if (value === null || value === undefined || value === '') {
        errors.push(field.message);
      }
    });

    if (errors.length > 0 && showError) {
      this.helperService.toasterService.error(errors[0]);
    }

    return errors.length === 0;
  }

  private canPersistRtmp(): boolean {
    if ((!this.quote) || (this.quote.id == 0))
      return false;

    //if there are no credits shown in the grid, then do not create obligations
    if (this.obligationData.length == 0)
      return false;

    if (!this.validateApplicant(false))
      return false;

    // payer dropdown must have a selection
    const payerValue = this.fgQuote.get('isPayerSameAsApplicant')?.value;
    if (!payerValue || payerValue === '')
      return false;

    if (!this.validatePayer(false))
      return false;

    if (!this.validateDevelopment(false))
      return false;

    return true;
  }

  public canSaveDraft(): boolean {
    if ((this.BCFPaymentReferenceNo != ""))
      return false;

    return this.canPersistRtmp();
  }

  public canUpdate(): boolean {
    if ((this.BCFPaymentReferenceNo == ""))
      return false;

    return this.canPersistRtmp();
  }

  public isApplicantAndContactValid(): boolean {
    return this.validateApplicant(false);
  }

  public isDevelopmentDetailsValid(): boolean {
    return this.validateDevelopment(false);
  }

  public isPayerDetailsValid(): boolean {
    return this.validatePayer(false);
  }

  public canSave(): boolean {
      return this.canSaveDraft();
  }

  public canSubmitRequest(): boolean {

    //draft not saved
    if (this.ObligationPaymentId == 0)
      return false;

    // Check if both consents are given
    if (!this.consent1 || !this.consent2)
      return false;

    // Check if at least one obligation is selected
    if (this.selectedObligationsCount <= 0) return false;

    if( !this.invoiceRequiredSelected) return false ;

    // Check if statutory documents are uploaded 
    if (this.statutoryUploaded ) return true;

    return false;
  }

  showValidationSummary(): boolean {

    if (this.ObligationPaymentId <= 0) return true;

    if (!this.statutoryUploaded ) {
      return true;
    }
    if (!this.consent1 || !this.consent2)
      return true;

    if(!this.invoiceRequiredSelected)
      return true ;

    if (this.selectedObligationsCount <= 0) return true;

    return false;
  }

  downloadFile(type) {

    if (type == 'QFEQSFile') {
      const file = this.documents.find(x => x.name == this.QFEQSFile);
      if (file)
        this.fileService.downloadFile(file.id, this.QFEQSFile);
    }
    if (type == 'QFNSWDEVFile') {
      const file = this.documents.find(x => x.name == this.QFNSWDEVFile);
      if (file)
        this.fileService.downloadFile(file.id, this.QFNSWDEVFile);
    }
    if (type == 'QFNSWAPRFile') {
      const file = this.documents.find(x => x.name == this.QFNSWAPRFile);
      if (file)
        this.fileService.downloadFile(file.id, this.QFNSWAPRFile);
    }
    if (type == 'QFCWAPRFile') {
      const file = this.documents.find(x => x.name == this.QFCWAPRFile);
      if (file)
        this.fileService.downloadFile(file.id, this.QFCWAPRFile);
    }
    if (type == 'QFCRFile') {
      const file = this.documents.find(x => x.name == this.QFCRFile);
      if (file)
        this.fileService.downloadFile(file.id, this.QFCRFile);

    }
  }

    onInvoiceRequiredChange($event) {
    const value = $event.target.value;
    this.invoiceRequired = value === 'yes';
    this.invoiceRequiredSelected = value === 'yes' || value === 'no';
  }

  public setShapeFileMessage(paymentReferenceNo: string = this.BCFPaymentReferenceNo): void {
    const paymentReference = (paymentReferenceNo || '').trim();
    const requestId = ++this.shapeFileStatusRequestId;
    this.shapeFileStatusPaymentReferenceNo = paymentReference;
    this.shapeFileUploaded = false;
    this.shapeFileMessage = paymentReference
      ? `Upload your shapefile for BCF payment number ${paymentReference} here`
      : 'Upload shapefile after saving draft and once BCF payment number is generated.';

    if (!paymentReference) {
      return;
    }

    this.quoteService.IsShapeFileReady(paymentReference).subscribe(
      (isReady: boolean) => {
        if (requestId !== this.shapeFileStatusRequestId
          || paymentReference !== this.shapeFileStatusPaymentReferenceNo) {
          return;
        }

        this.shapeFileUploaded = !!isReady;
        this.shapeFileMessage = isReady
          ? 'Shapefile uploaded'
          : `Upload your shapefile for BCF payment number ${paymentReference} here`;
      },
      () => {
        if (requestId !== this.shapeFileStatusRequestId
          || paymentReference !== this.shapeFileStatusPaymentReferenceNo) {
          return;
        }

        this.shapeFileUploaded = false;
        this.shapeFileMessage = `Upload your shapefile for BCF payment number ${paymentReference} here`;
      }
    );
  }

  public getShapeFileMessageClass(): string {
    if (!this.shapeFileStatusPaymentReferenceNo) {
      return "text-danger"; // Red - payment number not generated
    } else if (this.shapeFileUploaded) {
      return "text-success"; // Green - uploaded
    } else if (this.shapeFileMessage.includes("Upload your shapefile for BCF payment number")) {
      return "text-danger"; // Red - not uploaded
    }
    return "";
  }
}
